import dayjs from 'dayjs'

// Convert date object to YYYY-MM-DD string
export const dateParser = (date: Date) => {
  if (!date) {
    return null
  }
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()

  return [year, month, day].join('-')
}

//Convert input value to valid datepicker object
export const parseInputValue = (input, dayjsFormat = false) => {
  if (!input) return null
  let dateObj = input instanceof Date ? input : new Date(input)
  if (dateObj && isNaN(dateObj.getTime())) {
    console.error(`Invalid date: ${input}`)
    return null
  }
  if (dayjsFormat) return dayjs(input)
  return dateObj
}

//Ensure a JS Date object is returned (accepts Dayjs from MUI X pickers on UX3).
export const parseDateObject = (date): Date | null => {
  if (!date) return null
  if (date instanceof Date) {
    return isNaN(date.getTime()) ? null : date
  }
  if (dayjs.isDayjs(date)) {
    return date.isValid() ? date.toDate() : null
  }
  const parsed = new Date(date)
  return isNaN(parsed.getTime()) ? null : parsed
}
